var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* tslint:disable: class-name */
/*
 * AUTOGENERATED FILE - DO NOT EDIT
 */
import { ewJSONContractLine } from './ewJSONContractLine';
import { JSONStruct, array_property, nullable, property } from 'badphraim/data/JSONStruct';
export class ewJSONContract extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.eier = 0;
        /** @override */ this.id = 0;
        /** @override */ this.linjer = [];
    }
}
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContract.prototype, "avd", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONContract.prototype, "avtalenr", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewJSONContract.prototype, "bbs_status", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONContract.prototype, "binding_dato", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONContract.prototype, "eier", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContract.prototype, "fakturatype", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONContract.prototype, "gyldig_fra", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONContract.prototype, "gyldig_til", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONContract.prototype, "id", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONContract.prototype, "klasse", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContract.prototype, "klassetekst", void 0);
__decorate([
    array_property(ewJSONContractLine),
    __metadata("design:type", Array)
], ewJSONContract.prototype, "linjer", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContract.prototype, "nets_url", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewJSONContract.prototype, "status", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContract.prototype, "tekst", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONContract.prototype, "tittel", void 0);
